



















































































































































































































































































































































































































































































































































import { Vue, Component, Prop, Watch } from "vue-property-decorator";
import store from "@/store";

//  @types
import { ExtendedVessel } from "@/types/vessel";
import { LogVariable } from "@/types/logVariable";
import { FeatureAttribute } from "@/types/cds/featureAttribute";
//  modules
import { getModule } from "vuex-module-decorators";
import VesselsModule from "@/store/clients/Vessels.module";
import LogVariablesModule from "@/store/clients/LogVariables.module";
import CdsModule from "@/store/clients/Cds.module";

const Vessels = getModule(VesselsModule, store);
const LogVariables = getModule(LogVariablesModule, store);
const Cds = getModule(CdsModule, store);

interface LogVariableGroup {
  id: number;
  name: string;
  logVariableIds: string;
  logVariables: LogVariable[];
  cdsFeatureIds?: string;
  cdsFeatures?: FeatureAttribute[];
}

@Component({})
export default class FeatureLogVariables extends Vue {
  @Prop({ default: null }) value!: string | null;
  @Prop({ default: null, required: true }) logVariableIds!: string | null;
  @Prop({ default: null, required: true }) cdsFeatureIds!: string | null;

  // @Data
  FeatureLogVariableState: "Distinct" | "Group" = "Distinct";
  isFeaturesLogVariablesLoading = false;
  isGroupsLoading = false;
  searchFeatureLogVariableQuery = "";
  initialGroupList: LogVariableGroup[] = [];
  groupList: LogVariableGroup[] = [];
  selectedGroupList: LogVariableGroup[] = [];
  selectedGroup: LogVariableGroup | null = null;
  initialDistinctGroup: LogVariableGroup = {
    id: 0,
    name: "Distinct",
    logVariableIds: "",
    logVariables: [],
    cdsFeatures: [],
  };
  distinctGroup: LogVariableGroup = {
    id: 0,
    name: "Distinct",
    logVariableIds: "",
    logVariables: [],
    cdsFeatures: [],
  };

  // @Watchers
  @Watch("distinctGroup.logVariables", { deep: true })
  onDistinctLogVariablesChanged() {
    this.applySelection();
  }

  @Watch("distinctGroup.cdsFeatures", { deep: true })
  onDistinctCdsFeaturesChanged() {
    this.applySelection();
  }

  @Watch("selectedGroupList", { deep: true })
  onSelectedGroupListChanged() {
    this.applySelection();
  }

  @Watch("groupList", { deep: true })
  onGroupListChanged() {
    this.applySelection();
  }

  // @Getters
  get vessel(): ExtendedVessel | null {
    if (!Vessels.currentVessel) return null;
    return Vessels.currentVessel;
  }

  get featuresByVessel(): FeatureAttribute[] {
    if (!this.vessel) return [];
    return Cds.featuresByVessel(this.vessel.id) || [];
  }

  get filteredLogVariables(): LogVariable[] {
    if (this.searchFeatureLogVariableQuery) {
      return this.currentVesselLogVariables.filter(logVariable => logVariable.name.toLowerCase().includes(this.searchFeatureLogVariableQuery.toLowerCase()));
    }
    return this.currentVesselLogVariables;
  }

  get selectedGroupTotalCount(): number {
    if (!this.selectedGroup) return 0;
    return this.selectedGroup.logVariables.length + (this.selectedGroup.cdsFeatures?.length ?? 0);
  }

  get isSelectedGroupEmpty(): boolean {
    return this.selectedGroupTotalCount === 0;
  }

  get isSelectedGroupNotFull(): boolean {
    return this.selectedGroupTotalCount > 0 && this.selectedGroupTotalCount < 5;
  }

  get filteredFeatures(): FeatureAttribute[] {
    if (!this.vessel || this.isFeaturesLogVariablesLoading) return [];
    const cdsFeatures = Cds.featuresByVessel(this.vessel.id) || [];
    if (this.searchFeatureLogVariableQuery) {
      return cdsFeatures.filter(attribute => attribute.name.toLowerCase().includes(this.searchFeatureLogVariableQuery.toLowerCase()));
    }
    return cdsFeatures;
  }

  get isFeatureCheckboxDisabled() {
    return (feature: FeatureAttribute) =>
      this.distinctGroup.logVariables.length + (this.distinctGroup.cdsFeatures?.length ?? 0) >= 20 &&
      !this.distinctGroup.cdsFeatures?.some(f => f.id === feature.id) &&
      !this.distinctGroup.logVariables.some(lv => lv.id === feature.id);
  }

  get isGroupFeatureCheckboxDisabled() {
    return (feature: FeatureAttribute) =>
      this.selectedGroup && this.selectedGroup.logVariables.length + (this.selectedGroup.cdsFeatures?.length ?? 0) >= 5 && !this.selectedGroup.cdsFeatures?.some(f => f.id === feature.id);
  }

  get isGroupLogVariableCheckboxDisabled() {
    return (item: LogVariable) =>
      this.selectedGroup && this.selectedGroup.logVariables.length + (this.selectedGroup.cdsFeatures?.length ?? 0) >= 5 && !this.selectedGroup.logVariables.some(lv => lv.id === item.id);
  }

  get isDistinctLogVariableCheckboxDisabled() {
    return (item: LogVariable) => this.distinctGroup.logVariables.length + (this.distinctGroup.cdsFeatures?.length ?? 0) >= 20 && !this.distinctGroup.logVariables.some(lv => lv.id === item.id);
  }

  get selectedGroupLogVariables(): LogVariable[] {
    if (!this.selectedGroup) return [];
    const foundGroup = this.groupList.find(group => group.id === this.selectedGroup!.id);
    return foundGroup && foundGroup.logVariables ? foundGroup.logVariables : [];
  }
  set selectedGroupLogVariables(value: LogVariable[]) {
    if (this.selectedGroup) {
      this.selectedGroup.logVariables = value;
      this.selectedGroup.logVariableIds = value.map(lv => lv.id).join(",");
      // Update the groupList to reflect changes in the selectedGroup
      this.groupList = this.groupList.map(group =>
        this.selectedGroup && group.id === this.selectedGroup.id ? { ...group, logVariables: value, logVariableIds: value.map(lv => lv.id).join(",") } : group
      );
    }
  }

  get formattedSelectionResult(): string {
    const logVars = this.distinctGroup.logVariables.length;
    const features = this.distinctGroup.cdsFeatures?.length ?? 0;
    const groups = this.selectedGroupList.length;

    const result = [];
    if (features > 0) result.push(`Features (${features})`);
    if (logVars > 0) result.push(`Log Variables (${logVars})`);
    if (groups > 0) result.push(`Groups (${groups})`);

    return result.join(", ");
  }

  get isNoGroups(): boolean {
    return this.groupList.length === 0;
  }

  get currentVesselLogVariables(): LogVariable[] {
    return LogVariables.currentVesselLogVariables || [];
  }

  get hasAnySelection(): boolean {
    return this.distinctGroup.logVariables.length > 0 || (this.distinctGroup.cdsFeatures?.length ?? 0) > 0 || this.selectedGroupList.length > 0;
  }

  get featuresAndGroupsSelectedText(): string {
    const logVars = this.distinctGroup.logVariables.length;
    const features = this.distinctGroup.cdsFeatures?.length ?? 0;
    const groups = this.selectedGroupList.length;

    const result: string[] = [];

    if (features > 0) {
      result.push(`${features} feature${features === 1 ? "" : "s"}`);
    }
    if (logVars > 0) {
      result.push(`${logVars} log variable${logVars === 1 ? "" : "s"}`);
    }
    if (groups > 0) {
      result.push(`${groups} group${groups === 1 ? "" : "s"} selected`);
    }
    if (result.length === 0) {
      result.push("selected");
    }

    return result.join(", ");
  }

  // @Methods
  async fetchData(): Promise<void> {
    if (!this.vessel?.id) return;
    try {
      this.isFeaturesLogVariablesLoading = true;
      // Fetch log variables and features for the current vessel
      await LogVariables.refreshCurrentVesselLogVariables(this.vessel.id);
      await Cds.fetchVesselFeatures(this.vessel.id).then(() => {
        this.initGroupList(this.logVariableIds, this.cdsFeatureIds);
      });
    } catch (error) {
      console.error("Error fetching data:", error);
      return Promise.reject(error);
    } finally {
      this.isFeaturesLogVariablesLoading = false;
    }
  }

  setState(group: { id: number; name: string; logVariableIds: string; logVariables: LogVariable[] }): void {
    if (!group || group.name === "Distinct") {
      this.FeatureLogVariableState = "Distinct";
      this.selectedGroup = null;
      return;
    }
    this.selectedGroup = group;
    this.FeatureLogVariableState = "Group";
  }

  applySelection(): void {
    // Distinct group: join with ';'
    const distinctIds = this.distinctGroup.logVariables.map(lv => lv.id).join(";");
    const distinctFeatureIds = (this.distinctGroup.cdsFeatures ?? []).map(f => f.id).join(";");

    // Other groups: each group joined with ',' and then all groups joined with ';'
    const selectedGroupIds = this.selectedGroupList
      .map(group => group.logVariables.map(lv => lv.id).join(","))
      .filter(Boolean)
      .join(";");

    const selectedGroupFeatureIds = this.selectedGroupList
      .map(group => (group.cdsFeatures ?? []).map(f => f.id).join(","))
      .filter(Boolean)
      .join(";");

    const groupIds = this.groupList
      .map(group => group.logVariables.map(lv => lv.id).join(","))
      .filter(Boolean)
      .join(";");

    const groupFeatureIds = this.groupList
      .map(group => (group.cdsFeatures ?? []).map(f => f.id).join(","))
      .filter(Boolean)
      .join(";");

    // Combine into the required format
    const selectedLogVariableIds = selectedGroupIds ? `${distinctIds}|${selectedGroupIds}` : distinctIds;
    const logVariableIds = groupIds ? `${distinctIds}|${groupIds}` : distinctIds;

    const selectedCdsFeatureIds = selectedGroupFeatureIds ? `${distinctFeatureIds}|${selectedGroupFeatureIds}` : distinctFeatureIds;
    const cdsFeatureIds = groupFeatureIds ? `${distinctFeatureIds}|${groupFeatureIds}` : distinctFeatureIds;

    this.$emit("update:selectedLogVariableIds", selectedLogVariableIds);
    this.$emit("update:logVariableIds", logVariableIds);
    this.$emit("update:selectedCdsFeatureIds", selectedCdsFeatureIds);
    this.$emit("update:cdsFeatureIds", cdsFeatureIds);
  }

  addNewGroup(): void {
    const newGroup: LogVariableGroup = {
      id: this.groupList.length + 1,
      name: `Group #${this.groupList.length + 1}`,
      logVariableIds: "",
      logVariables: [],
      cdsFeatureIds: "",
      cdsFeatures: [],
    };

    this.groupList.push(newGroup);
    this.selectedGroupList.push(newGroup);
    this.setState(newGroup);

    // Scroll the features list to the top
    this.$nextTick(() => {
      const list = this.$refs.featuresListMenu as HTMLElement;
      if (list) list.scrollTo({ top: 0 });
    });
  }

  getGroupTotalCount(group: LogVariableGroup): number {
    return (group.logVariables?.length ?? 0) + (group.cdsFeatures?.length ?? 0);
  }

  clearDistinctAndGroupSelection(): void {
    // Clear distinct group
    this.distinctGroup.logVariables = [];
    this.distinctGroup.logVariableIds = "";
    this.distinctGroup.cdsFeatures = [];
    this.distinctGroup.cdsFeatureIds = "";

    // Clear all groups
    this.groupList.forEach(group => {
      group.logVariables = [];
      group.logVariableIds = "";
      group.cdsFeatures = [];
      group.cdsFeatureIds = "";
    });

    // Clear selected groups
    this.selectedGroupList = [];
  }

  removeFeatureLogVariable(id: number): void {
    this.distinctGroup.logVariables = this.distinctGroup.logVariables.filter(v => v.id !== id);
  }

  removeFeatureCdsFeature(id: number): void {
    this.distinctGroup.cdsFeatures = this.distinctGroup.cdsFeatures?.filter(f => f.id !== id) || [];
  }

  removeDistinctLogVariable(id: number): void {
    this.distinctGroup.logVariables = this.distinctGroup.logVariables.filter(v => v.id !== id);
    this.distinctGroup.logVariableIds = this.distinctGroup.logVariables.map(lv => lv.id).join(";");
  }

  removeDistinctFeature(id: number): void {
    this.distinctGroup.cdsFeatures = this.distinctGroup.cdsFeatures?.filter(f => f.id !== id) || [];
    this.distinctGroup.cdsFeatureIds = this.distinctGroup.cdsFeatures.map(f => f.id).join(";");
  }

  clearDistinctSelection(): void {
    this.distinctGroup.logVariables = [];
    this.distinctGroup.logVariableIds = "";
    this.distinctGroup.cdsFeatures = [];
    this.distinctGroup.cdsFeatureIds = "";
  }

  removeGroup(id: number): void {
    const groupIndex = this.selectedGroupList.findIndex(group => group.id === id);
    if (groupIndex !== -1) {
      this.selectedGroupList.splice(groupIndex, 1);
    }
  }

  deleteGroup(id: number): void {
    const groupIndex = this.groupList.findIndex(group => group.id === id);
    if (groupIndex !== -1) {
      this.groupList.splice(groupIndex, 1);
    }
    if (this.selectedGroup && this.selectedGroup.id === id) {
      this.selectedGroup = null;
      this.FeatureLogVariableState = "Distinct";
    }
  }

  removeGroupLogVariable(id: number): void {
    if (!this.selectedGroup) return;
    this.selectedGroup.logVariables = this.selectedGroup.logVariables.filter(lv => lv.id !== id);
    this.selectedGroup.logVariableIds = this.selectedGroup.logVariables.map(lv => lv.id).join(",");
  }

  removeGroupFeature(id: number): void {
    if (!this.selectedGroup) return;
    this.selectedGroup.cdsFeatures = this.selectedGroup.cdsFeatures?.filter(f => f.id !== id) || [];
    this.selectedGroup.cdsFeatureIds = this.selectedGroup.cdsFeatures.map(f => f.id).join(",");
  }

  editGroupLogVariables(id: number): void {
    // This method can be used to edit group log variables if needed
    console.log("Edit group log variables for group ID:", id);
  }

  cancelSelection(): void {
    this.groupList = JSON.parse(JSON.stringify(this.initialGroupList));
    this.distinctGroup = JSON.parse(JSON.stringify(this.initialDistinctGroup));
    this.selectedGroup = null;
    this.selectedGroupList = [];
    this.searchFeatureLogVariableQuery = "";
  }

  initGroupList(logVariableIds: string | null, cdsFeatureIds: string | null): void {
    this.initialGroupList = [];
    this.groupList = [];

    // Split into distinct and groups part
    const [distinctLogVarsPart = "", groupLogVarsPart = ""] = (logVariableIds || "").split("|");
    const [distinctCdsFeaturesPart = "", groupCdsFeaturesPart = ""] = (cdsFeatureIds || "").split("|");

    // Distinct group: ids separated by ';'
    const getDistinctIds = (idsStr: string) =>
      idsStr
        .split(";")
        .map(id => id.trim())
        .filter(Boolean);

    // Groups: groups separated by ';', ids inside group separated by ','
    const getGroupIds = (groupsStr: string) =>
      groupsStr.split(";").map(group =>
        group
          .split(",")
          .map(id => id.trim())
          .filter(Boolean)
      );

    // Get objects by ids
    const getLogVariables = (ids: string[]) => this.currentVesselLogVariables.filter(lv => ids.includes(String(lv.id)));
    const getFeatures = (ids: string[]) => this.featuresByVessel.filter(f => ids.includes(String(f.id)));

    // Distinct group
    const distinctLogVarIds = getDistinctIds(distinctLogVarsPart);
    const distinctCdsFeatureIds = getDistinctIds(distinctCdsFeaturesPart);

    this.initialDistinctGroup = {
      id: 0,
      name: "Distinct",
      logVariableIds: distinctLogVarsPart,
      logVariables: getLogVariables(distinctLogVarIds),
      cdsFeatureIds: distinctCdsFeaturesPart,
      cdsFeatures: getFeatures(distinctCdsFeatureIds),
    };
    this.distinctGroup = JSON.parse(JSON.stringify(this.initialDistinctGroup));

    // Groups
    const groupLogVarsArr = getGroupIds(groupLogVarsPart);
    const groupCdsFeaturesArr = getGroupIds(groupCdsFeaturesPart);
    const maxGroups = Math.max(groupLogVarsArr.length, groupCdsFeaturesArr.length);

    for (let i = 0; i < maxGroups; i++) {
      const logVarIds = groupLogVarsArr[i] || [];
      const cdsFeatureIds = groupCdsFeaturesArr[i] || [];
      const logVarIdsStr = logVarIds.join(",");
      const cdsFeatureIdsStr = cdsFeatureIds.join(",");
      const group: any = {
        id: i + 1,
        name: `Group #${i + 1}`,
        logVariableIds: logVarIdsStr,
        logVariables: getLogVariables(logVarIds),
        cdsFeatureIds: cdsFeatureIdsStr,
        cdsFeatures: getFeatures(cdsFeatureIds),
      };
      this.initialGroupList.push(group);
    }
    this.groupList = JSON.parse(JSON.stringify(this.initialGroupList));
  }

  // @Hooks
  async created(): Promise<void> {
    // Initialize default values
    await this.fetchData();
  }
}
